type StarIconProps = {
  shadow?: boolean;
};

const StarIcon: React.FC<StarIconProps & React.SVGAttributes<SVGElement>> = ({
  shadow,
  ...svgProps
}) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="currentColor"
      overflow="visible"
      {...svgProps}
    >
      {shadow && (
        <path
          d="M28.331 4.873c.641-2.076.962-3.113 1.291-3.54a3 3 0 0 1 4.756 0c.329.427.65 1.464 1.29 3.54l3.414 11.045h11.566c2.007 0 3.011 0 3.508.18a3 3 0 0 1 1.5 4.439c-.284.444-1.082 1.054-2.677 2.272l-9.52 7.273 3.535 11.44c.623 2.014.934 3.022.905 3.557a3 3 0 0 1-3.88 2.706c-.511-.158-1.35-.798-3.025-2.078L32 38.836l-8.994 6.87c-1.676 1.281-2.514 1.921-3.026 2.079a3 3 0 0 1-3.88-2.706c-.028-.535.283-1.543.906-3.557l3.535-11.44-9.52-7.273c-1.595-1.218-2.393-1.828-2.678-2.272a3 3 0 0 1 1.501-4.439c.497-.18 1.5-.18 3.508-.18h11.566l3.413-11.045Z"
          opacity={0.4}
        />
      )}
      <path d="M20.331 4.873c.641-2.076.962-3.113 1.291-3.54a3 3 0 0 1 4.756 0c.329.427.65 1.464 1.29 3.54l3.414 11.045h11.566c2.007 0 3.011 0 3.508.18a3 3 0 0 1 1.5 4.439c-.284.444-1.082 1.054-2.677 2.272l-9.52 7.273 3.535 11.44c.623 2.014.934 3.022.905 3.557a3 3 0 0 1-3.88 2.706c-.511-.158-1.35-.798-3.025-2.078L24 38.836l-8.994 6.87c-1.676 1.281-2.514 1.921-3.026 2.079a3 3 0 0 1-3.88-2.706c-.028-.535.283-1.543.906-3.557l3.535-11.44-9.52-7.273C1.426 21.591.628 20.981.343 20.537a3 3 0 0 1 1.501-4.439c.497-.18 1.5-.18 3.508-.18h11.566l3.413-11.045Z" />
    </svg>
  );
};

export default StarIcon;
